import React, { useMemo } from 'react';

import { get } from 'lodash';
import { FORM_WIDGET_COMPONENTS } from '../../../form/formConstants';
import FormWidget from '../../../form/FormWidget';
import { useI18n } from '../../../i18n/I18n';
import { DEFAULT_DURATION_UNIT_OPTIONS, SCHEDULE_FORM_WIDGET_FIELD_NAMES } from '../constants';
import useScheduleFormWidgetContext from '../useScheduleFormWidgetContext';
import { mapDurationUnitsDataToOptions } from '../utils/data-to-options-utils';
import { resolveStateFieldName } from '../utils/form-utils';

export interface ScheduleDurationUnitFormWidgetProps {
    name?: string;
    disabled?: boolean;
}

export default function ScheduleDurationUnitFormWidget({
    name: nameProp,
    disabled: disabledProp = false
}: ScheduleDurationUnitFormWidgetProps) {
    const t = useI18n();

    const { loading, error, disabled, durationUnitsData, allowedDurationUnits } = useScheduleFormWidgetContext();

    const durationUnitOptions = useMemo(() => {
        if (loading || !durationUnitsData || durationUnitsData.length === 0) {
            return DEFAULT_DURATION_UNIT_OPTIONS;
        }

        const durationUnitOptions = mapDurationUnitsDataToOptions(durationUnitsData, allowedDurationUnits);

        return durationUnitOptions;
    }, [allowedDurationUnits, durationUnitsData, loading]);

    const name = resolveStateFieldName([nameProp, SCHEDULE_FORM_WIDGET_FIELD_NAMES.DURATION_UNIT]);

    const isWidgetDisabled = disabled || disabledProp || loading;

    const widgetErrors = get(error, name);

    return (
        <FormWidget
            component={FORM_WIDGET_COMPONENTS.autocomplete}
            name={name}
            label={t('durationUnitFormWidget.label')}
            options={durationUnitOptions}
            disabled={isWidgetDisabled}
            hasErrors={Boolean(widgetErrors)}
            errors={widgetErrors}
            disableClearable
        />
    );
}
